import { StencilCDNImage } from '@/components/Common/StencilImage'
import Text from '@/stories/components/Common/NewText'
import classNames from 'classnames'

const Widget = ({
  title,
  published_at,
  img_url,
  isBorder,
}: {
  title: string
  published_at: string
  img_url: string
  isBorder: boolean
}) => {
  return (
    <div
      className={classNames('flex flex-row justify-between  py-3', {
        'border-brand-grey-base/40 border-b': isBorder,
      })}
    >
      <div className="flex w-[60%] flex-col pr-2 lg:w-[75%]">
        {title && (
          <Text appearance="subtitle2" addClassName="tect-brand-black">
            {title}
          </Text>
        )}
        {published_at && (
          <Text appearance="caption" addClassName=" text-brand-grey-base">
            {published_at}
          </Text>
        )}
      </div>
      <div className="flex h-[70px] flex-1 justify-end px-2">
        {img_url && (
          <StencilCDNImage
            src={img_url}
            width={119}
            height={69}
            alt={title}
            className="rounded-md"
          />
        )}
      </div>
    </div>
  )
}

export default Widget
